import React from 'react';
import './token-redemption-owner-result.scss';
import SuccessIcon from 'assets/icons/success.svg';
import { SearchIcon } from 'assets/icons';
import { IconBtn } from '@ru-digital-assets/ui-component';
import currencyFormat from 'utils/currencyFormat';
import { useHistory } from 'react-router';
import { CopyIcon } from 'assets/icons';

interface ITokenRedemptionOwnerResult {
  asset: any;
}

export default function TokenRedemptionOwnerResult({
  asset,
}: ITokenRedemptionOwnerResult) {
  const history = useHistory();

  return (
    <div className="token-redemption-owner-result">
      <img src={SuccessIcon} alt="Погашение успешно инициировано" />
      <p className="p p_font-size_32 p_font-weight_light mt_32 mb_32">
        Токены успешно погашены
      </p>
      <p className="p p_font-size_18 mb_32 text-center">
        {asset.actualCount} токенов {asset.issuingInfo.tokenName} на
        сумму{' '}
        {currencyFormat(
          asset.actualCount * asset.issuingInfo.tokenPrice,
          true
        )}
        <br />
        Обладателя {asset.owner} успешно погашены
      </p>
      <div className="flex align-center mb_32">
        <p className="p p_font-size_18 mr_10">
          ID транзакции:{' '}
          {asset.blockchainTransactionId.slice(0, 20) +
            '..' +
            asset.blockchainTransactionId.slice(-15)}
        </p>
        <CopyIcon
          className="cursor-pointer"
          width={20}
          height={20}
          onClick={() => {
            navigator.clipboard.writeText(asset.blockchainTransactionId);
          }}
        />
      </div>
      <div className="flex">
        <div className="mr_16">
          <IconBtn
            title="Посмотреть транзакцию в блокчейн Explorer"
            outlined
            icon={<SearchIcon />}
            onClick={() => {
              window!.open(`https://explorer.cfa.digital/tx/${asset.blockchainTransactionId}`, '_blank')!.focus();
            }}
          />
        </div>
        <IconBtn
          title="Перейти в активы"
          onClick={() => {
            history.push('/assets');
          }}
        />
      </div>
    </div>
  );
}
